import React, { useState } from 'react'
import axios from 'axios'
import { Link, useLocation } from 'react-router-dom'
import { useLanguage } from '../Context/LanguageContext'

const ResetPassword = () => {
  const location = useLocation()
  const { getLocalizedPath } = useLanguage()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const urlParams = new URLSearchParams(location.search)
  const token = urlParams.get('code') || urlParams.get('token')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')
    setError('')

    if (password !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters.')
      return
    }

    if (!token) {
      setError('This reset link is invalid or has expired. Please request a new password reset from the Imigo app.')
      return
    }

    try {
      setSubmitting(true)
      await axios.post('https://panel.imigo.app/api/auth/reset-password', {
        password,
        passwordConfirmation: confirmPassword,
        code: token,
      })
      setMessage('Password reset successful! You can now log in with the Imigo app.')
    } catch (err) {
      const apiMessage = err.response?.data?.error?.message
      setError(apiMessage || 'Unable to reset password. The link may have expired. Please try again from the app.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="imigo-auth-page imigoAnimationBg">
      <div className="imigo-auth-card">
        <Link to={getLocalizedPath('/')} className="inline-block mb-3 text-sm font-semibold" style={{ color: 'var(--imigo-teal)' }}>
          ← Imigo
        </Link>
        <h1>Reset password</h1>
        <p>Choose a new password for your Imigo account.</p>

        {!token && (
          <div className="alert-warning-imigo" role="alert">
            Open this page from the password reset email link. The link must include a secure reset code.
          </div>
        )}

        {message ? (
          <div>
            <p className="alert-success-imigo">{message}</p>
            <a
              href="https://apps.apple.com/us/app/imigo-connect/id6744267446"
              className="btn-imigo-primary inline-block text-center no-underline mb-2"
              style={{ display: 'block', textDecoration: 'none' }}
            >
              Open Imigo App
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control-imigo"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={6}
            />
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control-imigo"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={6}
            />
            <button type="submit" className="btn-imigo-primary" disabled={submitting}>
              {submitting ? 'Resetting…' : 'Reset password'}
            </button>
            <button
              type="button"
              className="btn-imigo-ghost"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? 'Hide passwords' : 'Show passwords'}
            </button>
          </form>
        )}

        {error && <p className="alert-error-imigo">{error}</p>}
      </div>
    </div>
  )
}

export default ResetPassword
